module.exports = __webpack_public_path__ + "static/media/campaign-thumbnail-smishing.cbc63e49.png";